import * as React from 'react';

import { IDataContextProps, IScore } from '../types';

export const DataContext = React.createContext<IDataContextProps>({
  scores: [],
  details: [],
  setScores: () => null,
  setDetails: () => null,
});

const sortScoresByValue = (scores: IScore[], value: string) => {
  function compare(a: IScore, b: IScore) {
    if (a[value as keyof IScore] < b[value as keyof IScore]) {
      return -1;
    }
    if (a[value as keyof IScore] > b[value as keyof IScore]) {
      return 1;
    }
    return 0;
  }

  return scores.sort(compare);
};

export function DataProvider({ children }: { children: React.ReactNode }) {
  const [scores, setScores] = React.useState<Array<IScore>>([]);
  const [details, setDetails] = React.useState<Array<IScore>>([]);

  const setScoresHandler = React.useCallback(
    (value: Array<IScore>) => setScores(value),
    [],
  );
  const setDetailsHandler = React.useCallback(
    (value: Array<IScore>) => setDetails(value),
    [],
  );

  const context = React.useMemo(
    () => ({
      scores,
      setScores: setScoresHandler,
      setDetails: setDetailsHandler,
      details,
    }),
    [scores, setScoresHandler],
  );

  return (
    <DataContext.Provider value={context}>{children}</DataContext.Provider>
  );
}
